<template>
    <div class="price">
        开票金额：<span><sub>¥</sub>{{ price | NumFormat }}</span>
    </div>
</template>

<script>
export default {
    props: {
        price: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style lang="scss" scoped>
.price {
    font-size: 28px;
    color: #000;
    text-align: center;
    line-height: 56px;
    background-color: #fff;
    padding: 30px 0 34px;
    span {
        vertical-align: bottom;
        color: #FF7A45;
        font-size: 40px;
        sub {
            display: inline-block;
            margin-right: 4px;
            font-size: 28px;
        }
    }
}
</style>